import ROOT_API from '../rootapi'
import ajax from '@/utils/ajax'
export default {
  getBanners (p) {
    return new Promise(function (resolve, reject) {
      ajax.post(ROOT_API, '/recommendinfo/search', p, r => {
        resolve(r)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/bylBaseCenter/base/banner.js